import React from "react";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import Auth from "./Auth";
import AuthFooter from "./AuthFooter";
import { useLocation } from "../util/router";

function AuthSection(props) {
  // get the next path and place it in the url
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const existingNext = params.get("next")
  const encodedNext = existingNext ? encodeURIComponent(existingNext) : null
  
  // Options by auth type
  const optionsByType = {
    signup: {
      // Top Title
      title: "Step 2: Create an Account",
      // Button text
      buttonAction: "Sign up",
      // Footer text and links
      showFooter: true,
      signinText: "Already have an account?",
      signinAction: "Sign in",
      signinPath: props.expedited ? `/auth/signin?expedited=1&plan=${props.expeditedPlan}&referee=${props.expeditedRef}${encodedNext ? `&next=${encodedNext}` : ""}` : `/auth/signin${encodedNext ? `?next=${encodedNext}` : ""}`,
      // Terms and privacy policy agreement
      showAgreement: true,
      termsPath: "/legal/terms-of-service",
      privacyPolicyPath: "/legal/privacy-policy",
    },
    signin: {
      title: "Welcome Back!",
      buttonAction: "Sign in",
      showFooter: true,
      signupAction: "Create an account",
      signupPath: props.expedited ? `/signup?expedited=1&plan=${props.expeditedPlan}&referee=${props.expeditedRef}${encodedNext ? `&next=${encodedNext}` : ""}` : `/signup${encodedNext ? `?next=${encodedNext}` : ""}`,
      forgotPassAction: "Forgot Password?",
      forgotPassPath: "/auth/forgotpass",
      termsPath: "/legal/terms-of-service",
      privacyPolicyPath: "/legal/privacy-policy",
    },
    forgotpass: {
      title: "Get a new password",
      buttonAction: "Reset password",
      showFooter: true,
      signinText: "Remember it after all?",
      signinAction: "Sign in",
      signinPath: "/auth/signin",
      termsPath: "/legal/terms-of-service",
      privacyPolicyPath: "/legal/privacy-policy",
    },
    changepass: {
      title: "Choose a new password",
      buttonAction: "Change password",
      termsPath: "/legal/terms-of-service",
      privacyPolicyPath: "/legal/privacy-policy",
    },
  };

  // Ensure we have a valid auth type
  const type = optionsByType[props.type] ? props.type : "signup";

  // Get options object for current auth type
  const options = optionsByType[type];

  return (
    <Section
      size={props.size}
      bgColor={props.bgColor}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
      textColor={props.textColor}
    >
      <div className="container min-w-md max-w-md">
        <SectionHeader
          title={options.title}
          subtitle=""
          strapline=""
          className="text-center"
        />
        <Auth
          type={type}
          buttonAction={options.buttonAction}
          providers={props.providers}
          afterAuthPath={props.afterAuthPath}
          key={type}
        />

        {options.showFooter && <AuthFooter type={type} {...options} />}
      </div>
    </Section>
  );
}

export default AuthSection;
